/*
  Version: v01
  File: CertifiedBankCardHeader_v01.tsx
  Description: Header component split from the original CertifiedBankCard landing page.
*/

import React from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { Logo, ContactPhoneNumber } from './CertifiedBankCardUtility';


export default function CertifiedBankCardHeader_v01(): React.JSX.Element {
  return (
    <Navbar expand="lg" bg="white" className="border-bottom shadow-sm py-3 sticky-top">
      <Container>
        <Navbar.Brand href="/">
          {/* Certified<span style={{ color: '#082042' }}>BankCard</span> */}
          <Logo></Logo>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="cbc-navbar-nav" />
        <Navbar.Collapse id="cbc-navbar-nav">
          <Nav className="ms-auto gap-lg-3">
            <Nav.Link href="#services-overview">Services</Nav.Link>
            <Nav.Link href="#why-businesses-reach-out">Why Us</Nav.Link>
            <Nav.Link href="#industries-served">Industries</Nav.Link>
            <Nav.Link href="#get-started-form">Get Started</Nav.Link>
            
            &nbsp;&nbsp;&nbsp;&nbsp;

            <Nav.Link href="#">
              <ContactPhoneNumber phoneNumber_tel="18884600994" phoneNumberFormatted="(888) 460-0994"/>
            </Nav.Link>
            

      
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

/*
  File Name: CertifiedBankCardHeader_v01.tsx
  Quick Description: Header component for the CertifiedBankCard landing page.
  Version: v01
*/
